import { action, observable } from 'mobx';
import LoginConfigService from './LoginConfigService';

class LoginConfigStore {
    @observable loginConfig = null;

    async loadLoginConfig() {
        const loginConfig = await LoginConfigService.getLoginConfig();
        this.setLoginConfig(loginConfig);
    }

    @action
    setLoginConfig(loginConfig) {
        this.loginConfig = loginConfig;
    }
}
export default new LoginConfigStore();
